import React from 'react';
import Wrapper from '../LandingBlockWrapper/BlockWrapper';
import { Col, Row } from 'antd';

import icon6 from '../../assets/images/gallery/Camera02_background.png';
import icon2 from '../../assets/images/gallery/Camera03_background.png';
import icon4 from '../../assets/images/gallery/Camera04_background.png';
import icon3 from '../../assets/images/gallery/Camera05_background.png';
import icon5 from '../../assets/images/gallery/Camera06_background.png';
import icon1 from '../../assets/images/gallery/Camera07_background.png';

const list = [
	icon1, icon2, icon3, icon4, icon5, icon6
];

export default () => (
	<Wrapper className='Gallery'>
		<Row type="flex" >
			{list.map((img, i) =>
				<Col className="galleryItem" xs={24} sm={12} md={8} lg={8} key={i}>
					<img src={img} alt={`gallery_${i}`}/>
				</Col>)
			}
		</Row>
	</Wrapper>
);




// WEBPACK FOOTER //
// ./src/components/LandingGallery/Gallery.js